import { useContext, ref } from '@nuxtjs/composition-api'
import { useLoading } from './ui/useLoading'
import { Faq } from '~/types/faq'

export const useFaqList = () => {
  const { app } = useContext()

  const mainFaq = ref<Faq | null>(null)
  const mainFaqLoading = useLoading()
  const subFaqsLoading = useLoading()
  const subFaqs = ref<Faq[]>([])

  const getMainFaq = () => {
    return mainFaqLoading.scope(async () => {
      mainFaq.value = await app.$api.faq.getFaqByName('mainfaq')
    })
  }

  const getSubFaqs = () => {
    return subFaqsLoading.scope(async () => {
      const queue: Array<() => Promise<Faq | null>> = []

      mainFaq.value?.children?.forEach((faq) => {
        queue.push(() => {
          return app.$api.faq.getFaqByName(faq.key)
        })
      })

      if (!queue.length) return

      const result = await Promise.all(queue.map((e) => e()))
      subFaqs.value = result.filter((item) => !!item) as Faq[]
    })
  }

  return {
    mainFaq,
    mainFaqLoading: mainFaqLoading.value,
    getMainFaq,

    subFaqs,
    subFaqsLoading: subFaqsLoading.value,
    getSubFaqs,
  }
}
